import { call, put, takeEvery } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { PUSH } from 'constants/messageMediums';
import { getInAppContent, previewTemplate } from 'api/TemplatePreviewAPI';
import {
  getInAppContentError,
  getInAppContentResponse,
  previewTemplateError,
  previewTemplateResponse,
} from './actions';
import * as actionTypes from './actionTypes';
import { getPreviewLocation } from './utils';
import { ANDROID, IOS } from './constants';

export function* previewTemplateSaga({
  templateId,
  messageMedium,
  showAndroid,
  showExpanded,
  showLighthouseVersion,
  locale,
}) {
  try {
    const { data } = yield call(
      previewTemplate,
      templateId,
      messageMedium,
      showAndroid,
      showExpanded,
      showLighthouseVersion,
      locale,
    );
    const reduxKey = getPreviewLocation(showAndroid, showExpanded, locale);
    let activePushDeviceWrapper;
    if (messageMedium === PUSH) {
      activePushDeviceWrapper = showAndroid ? ANDROID : IOS;
    }
    yield put(previewTemplateResponse(templateId, data, reduxKey, activePushDeviceWrapper));
  } catch (error) {
    yield put(previewTemplateError(templateId));
  }
}

export function* getInAppContentSaga({ templateId }) {
  try {
    const { data } = yield call(getInAppContent, templateId);
    const { inAppDisplaySettings, inboxMetadata } = data.content;
    yield put(getInAppContentResponse(templateId, inAppDisplaySettings, inboxMetadata));
  } catch (error) {
    yield put(getInAppContentError());
  }
}

addToRootSaga([
  takeEvery(actionTypes.PREVIEW_TEMPLATE_REQUEST, previewTemplateSaga),
  takeEvery(actionTypes.GET_IN_APP_CONTENT_REQUEST, getInAppContentSaga),
]);
